import { gql } from '@apollo/client'

import { INVITATION_FRAGMENT } from '../fragments'

export const UPDATE_INVITATION = gql`
  mutation UpdateInvitation($data: UpdateInvitationInput!) {
    updateInvitation(data: $data) {
      ...Invitation
    }
  }
  ${INVITATION_FRAGMENT}
`
